
import { defineComponent } from 'vue';
import store from '@/store';
import { UserModel } from '@/interfaces/users/user.model';
import { GlobalPagination } from '@/interfaces/panel/global-pagination.model';
import UsersTableComponent from '@/components/usersComponents/UsersTable.vue';
import UserProfileInfo from '@/views/UserProfileInfo.vue';
import CustomPaginationComponent from '@/components/appComponents/CustomPagination.vue';
import IpgTransactionSkelton from '@/components/transactionsComponents/IpgTransactionSkelton.vue';

export default defineComponent({
    name: 'UsersListPage',
    
    components: {
        UsersTableComponent,
        UserProfileInfo,
        CustomPaginationComponent,
        IpgTransactionSkelton,
    },
    
    data() {
        return {
            statusComponent: 'users' as 'users' | 'profile' as 'users' | 'profile' | 'lastLogin' | 'cashout' | 'log' | 'merchants' | 'identify' | 'accountBlockHistory',
            user: '',
            activeFilterButton: 'all',
            buttons: [
                { title: 'همه کاربران', value: 'all' },
                { title: 'کاربران عادی', value: 'USER' },
                { title: 'کاربران کسب‌وکار', value: 'BUSINESS' },
            ],
            search: {
                name: '',
                email: '',
                phone: '',
            },
        };
    },
    computed: {
        getLoadingPanel(): boolean {
            return store.getters['panel/getLoadingPanel'];
        },
        getAllUsers(): UserModel[] {
            return store.getters['panel/getAllUsers'];
        },
        getGlobalPagination(): GlobalPagination {
            return store.getters['panel/getGlobalPagination'];
        },
    },
    methods: {
        back(): void {
            this.$emit('back');
        },
        handelPagination() {
            store.dispatch('panel/getAllUsersRequest', {
                type: this.activeFilterButton,
                filters: this.search,
                page: store.getters['panel/getGlobalActivePage'],
            });
        },
        setFilterOfUsersList(type: string): void {
            this.activeFilterButton = type;
            store.dispatch('panel/setGlobalActivePage', 1);
            store.dispatch('panel/getAllUsersRequest', {
                type,
                filters: this.search,
                page: 1,
            });
        },
        performSearch(): void {
            store.dispatch('panel/setGlobalActivePage', 1);
            store.dispatch('panel/getAllUsersRequest', {
                type: this.activeFilterButton,
                filters: this.search,
                page: 1,
            });
        },
        toggleAccessAccount(user: { userId: string; block: boolean }): void {
            store.dispatch('panel/userAccessAccountRequest', user);
        },
        toggleUserCashout(user: { userId: string; cashout: boolean }): void {
            store.dispatch('panel/userCashOutRequest', user);
        },
        togglePanelAccess(user: { userId: string; access: boolean }): void {
            store.dispatch('panel/userPanelAccessRequest', user);
        },
        handleUserOption(data: { userId: string; path: string }): void {
            this.user = data.userId;
            switch (data.path) {
                case 'lastLogin':
                    this.statusComponent = 'lastLogin';
                    break;
                case 'cashout':
                    this.statusComponent = 'cashout';
                    break;
                case 'log':
                    this.statusComponent = 'log';
                    break;
                case 'profile':
                    this.statusComponent = 'profile';
                    break;
                case 'merchants':
                    this.statusComponent = 'merchants';
                    break;
                case 'identify':
                    this.statusComponent = 'identify';
                    break;
                case 'accountBlockHistory':
                    this.statusComponent = 'accountBlockHistory';
                    break;
                default:
                    break;
            }
        },
    },
});
